import { observable } from 'mobx';
import { query, serviceQueries } from '@estee/elc-service-bus';
import { DCInventory, IDCInventory } from '~domain/entities/DCInventory';
import { HomeDeliveryAvailability } from '~constants/constants';

interface ISku {
    skuId: string;
    isShoppable: boolean;
}
interface IProductData {
    productId: string;
    isShoppable: boolean;
    skus: ISku[];
}

export class DCInventoryRepository {
    @observable public inventory: IDCInventory[];
    @observable public skuId: string;
    @observable public isShoppable: boolean;

    public loadInventory = async (skuId: string) => {
        this.skuId = skuId;
        const productData = (await query(serviceQueries.GET_PRODUCT_DATA, {
            filterBy: {
                skus: {
                    skuIds: [this.skuId]
                }
            }
        })) as IProductData[];

        const productId = productData[0]?.productId;
        const sku = productData[0]?.skus.find((skuToFind) => skuToFind.skuId === this.skuId);
        this.isShoppable = !!sku?.isShoppable;

        const invResponse = (await query(serviceQueries.GET_INVENTORY, [
            productId
        ])) as IDCInventory[];

        this.inventory = invResponse.map((inv) => DCInventory.fromJson(inv));
    };

    public getDCAvailabilityMessage = () => {
        return (
            this.inventory?.filter((inv) => inv.skuId === this.skuId)[0]?.status ||
            HomeDeliveryAvailability.AVAILABLE
        );
    };
}
